import { createStore } from "vuex";
import axios from 'axios'

export default createStore({
  state: {
    status: '',
    user: {},
    isLoading:false,
    val:'',
    toggle:true,
    dotsLoading:false,
    dbFrequency:[],
    dbPriority:[],
    labelsStatus:'',
    dbLabelsObject:{},
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, user) {
      state.status = 'success'
      state.user = user
    },
    auth_error(state) {
      state.status = 'error'
    },
    labels_request(state){
        state.labelsStatus = 'loading'
    },
    labels_success(state,labelsData){
        state.labelsStatus = 'success'
        state.dbLabelsObject = labelsData
        labelsData.map((item:any)=>{
          switch(item.entityId){
            case 20413:
              state.dbPriority = item.values;
              break;
            case 20417:
              state.dbFrequency = item.values;
              break;
            }  
        })
    },
    logout(state) {
      state.status = ''
    },
    setDotsLoading(state, newValue) {
      state.dotsLoading = newValue;
  },
  },
  actions: {
    getUserInfo({ commit }) {
      // console.log("hjhhh",process.env.VUE_APP_AUTH_API_URL)
      commit('auth_request')
      return new Promise((resolve, reject) => {
        axios({
          url: `${process.env.VUE_APP_AUTH_API}/userInfo/get`,
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
          }
        })
        .then(resp => {
          // console.log('response in store',resp);
          const user = resp.data[0];
          user.currentRole = user.roles.find((role:any) => { return role.appId == 10002 }).roleId
          // console.log('user',user);
          commit('auth_success', user)
          this.dispatch('getLabels')
          resolve(resp)
        })
        .catch(err => {
            commit('auth_error');
            reject(err);
            localStorage.removeItem('AUTH_ID');
            // window.location.href = window.location.origin+'/monitor/onboarding'
            // window.location.href = 'http://localhost:8080'
            window.location.href = `${process.env.VUE_APP_AUTH_UI}/?returnTo=${process.env.VUE_APP_AUDIT_UI}`
          })
      })
    },
    getLabels({commit}){
        commit('labels_request')

        return  new Promise((resolve, reject) => {
            axios({
            url: `${process.env.VUE_APP_ORG_API}/api/org/labels/getall`,
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
              }
        })
        .then(resp => {
                commit('labels_success', resp.data);
                resolve(resp)
            })
        .catch(err => {
                commit('labels_error')
                reject(err);
            })
        })
    },
    updateDotsLoading({ commit }, newValue) {
      commit('setDotsLoading', newValue);
    },
    logout({ commit }) {
      return new Promise<void>((resolve) => {
        commit('logout');
        resolve();
      })
    },
    selectedRoute(context, payload) {
      context.state.val=payload
     },
     selectedToggle(context, payload) {
      // console.log("Ssss",payload)
      context.state.toggle=payload
     }
  },
  getters: {
    authStatus: state => state.status,
    userInfo: state => state.user,
    loading:state=>state.isLoading,
    val:state=>state.val,
    toggle:state=>state.toggle,
    dotsLoading:state=>state.dotsLoading,
    dbFrequency:state => state.dbFrequency,
    dbPriority:state  => state.dbPriority
  }
});